import { PhoneApps } from '~/shared';
import { createSlice } from '../wrappers';

interface IPhoneSlice {
	activeApp: PhoneApps;
	activeWallpaper: number;
	brightness: number;
}

const initialState: IPhoneSlice = {
	activeApp: PhoneApps.MAIN,
	activeWallpaper: 0,
	brightness: 1,
};

const phoneSlice = createSlice({
	name: 'phone',
	initialState,
	reducers: {
		setActiveApp: (state, action) => {
			state.activeApp = action.payload;
		},
		setActiveWallpaper: (state, action) => {
			state.activeWallpaper = action.payload;
		},
		setBrightness: (state, action) => {
			state.brightness = action.payload;
		},
		returnToMain: (state) => {
			state.activeApp = PhoneApps.MAIN;
		},
	},
});

export const { setActiveApp, setActiveWallpaper, returnToMain, setBrightness } =
	phoneSlice.actions;

export default phoneSlice.reducer;
